module.exports = __webpack_public_path__ + "img/1F6BB.2e36898c.svg";